/**
 * API paths for various CRUD operations
 */
export const apiPaths = {
  // Authentication
  Signup: "auth/signup",
  VerifySignupOtp: "auth/signup/verify",
  Signin: "auth/login",
  ForgotPassword: "auth/forgot-password",
  verifyOTP: "auth/forgot-password/verify",
  VerifyPassword: "auth/forgot-password",
  Google: "auth/google",
  logout: "auth/logout",

  // Categories
  getCategories: "category",

  // Products - Updated for new product system
  getProducts: "products", // GET /products with query params for filtering
  getProductDetails: "products", // GET /products/:id for product details
  getProductFilters: "products/filters", // GET /products/filters
  // Updated endpoints for new backend API structure
  homeProducts: "products/home", // GET /products/home - Main home endpoint with newArrivals, featured, bestsellers
  newArrivals: "products/new-arrivals", // GET /products/new-arrivals
  bestSellers: "products/featured", // GET /products/featured (bestsellers are featured products)
  SearchProducts: "products", // Updated search endpoint
  updateProductView: 'products/view', // Updated view tracking 

  // Cart - Updated for new cart system
  addToCart: "cart",
  getCartProducts: "cart", 
  updateQuantity: "cart/item", // PUT /cart/item/:cartId
  removeFromCart: "cart/item", // DELETE /cart/item/:cartId
  clearCart: "cart/clear", // POST /cart/clear
  getCartSummary: "cart/summary", // GET /cart/summary
  syncCart: "cart/sync", // POST /cart/sync

  addComboToCart: "cart/combo", // POST /cart/combo

  // Banner
  getBanner: "banner",

  // Profile
  getProfile: "profile",
  UpdateProfile: "profile",

  // Address
  AddAddress: "profile/address",
  getAddress: "profile/address",
  deleteAddress: "profile/address",

  // Payment
  verifyPayment: "/order/verify",

  // Order
  orderHistory: "order/order-history",
  createOrder: "order",
  calculateDistance: "order/distance",

  // Wishlist - Updated to work with new product system
  wishlist: "profile/wishlist",
  toggleWishlist: "profile/wishlist", // POST /profile/wishlist

  // Rating - Updated for new product system
  addRatings: "rating",
  getRatings: "rating",
  updateReview: "rating",
  deleteReview: "rating",
  likeRating: "rating/like",
  disLikeRating: "rating/dislike",

  // Offers/Coupons
  getActiveCoupons: "coupon/active/all",
  applyCoupon: "coupon",

  // Distributor
  DistributorInquiry: "distributors",

  // New endpoints for product variants (if needed for admin)
  getProductVariants: "product/variants", // GET /product/variants/:productId
  
  // New endpoints for product sets (if needed)
  getProductSets: "product/sets", // GET /product/sets
  getProductSetDetails: "product/sets/details", // GET /product/sets/details/:id



  featuredProducts: "products/featured",   // GET /api/products/featured
  filterOptions: "products/filters", 
};